import React, {useEffect, useState} from 'react'
import {useRequest} from "ahooks";
import {FormSelect} from "../../FormSelect";
import thicknessService from "../../../../../services/thicknessService";
import ThicknessOffCanvas from "./ThicknessOffCanvas";
import {useFormikContext} from "formik";
import CanvasCreateEditButtons from "../../../UI/Canvas/CanvasCreateEditButtons";
import {ThicknessTypeEnum} from "../../../../../constants/enums/ThicknessTypesEnum";
import {toast} from "react-toastify";

const ThicknessPicker = ({name, type, onSelected, withCreate}) => {

    const {data, loading, runAsync} = useRequest(thicknessService.selectable);

    const [currentSelected, setCurrentSelected] = useState(undefined);
    const {values, setFieldValue} = useFormikContext()
    const [isCanvasOpen, setIsCanvasOpen] = useState(false);

    useEffect(() => {
        if (loading)
            return;

        if (values[name]) {
            const option = data.find(d => d.value === values[name])
            option
                ? thicknessService.fetch(option.uuid).then(res => setCurrentSelected(res))
                : setCurrentSelected(undefined)
        } else {
            setCurrentSelected(undefined)
        }

    }, [data, values[name]])

    const handleResponse = (value) => {
        runAsync().then(() => {
            onSelected({
                value: value.id,
                label: value.name
            })
            setIsCanvasOpen(false)
        })
    }

    const handleDelete = () => {
        thicknessService.destroy(currentSelected.uuid)
            .then(res => runAsync()
                .then(() => {
                    setFieldValue(name, undefined)
                    toast.success('Operazione eseguita con successo')
                })
            ).catch(err => toast.error(err.response.data.message))
    }

    useEffect(() => {
        setCurrentSelected((data || []).find(d => d.value === values[name]))
    }, [values[name]]);

    return (
        <React.Fragment>
            <FormSelect
                name={name}
                onChange={(thickness) => onSelected(data.find(d => d.value === thickness))}
                loading={loading}
                placeholder="Seleziona uno spessore"
                options={data}
                multiple={false}
            />

            {withCreate &&
                <>
                    <CanvasCreateEditButtons
                        value={values[name]}
                        canvasOpen={isCanvasOpen}
                        setCanvasOpen={setIsCanvasOpen}
                        handleDelete={handleDelete}
                    />

                    <ThicknessOffCanvas
                        isOpen={isCanvasOpen}
                        toggle={setIsCanvasOpen}
                        data={currentSelected}
                        handleResponse={handleResponse}
                        type={type || ThicknessTypeEnum.glass}
                    />
                </>
            }

        </React.Fragment>
    )
}

export default ThicknessPicker